// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react'
import { Link } from 'react-router-dom'
import { Checkbox, Menu, Image } from 'semantic-ui-react'

import { isAuthenticated, logout } from 'services/self'
import { persistDarkModePreference, readDarkModePreference } from 'services/dark-mode'
import { isAIAssistantEnabled, isPolicyStateChangeEnabled } from 'services/config'

// mobx
import { observer } from 'mobx-react'

// fragments
import { fragments } from 'services/get-fragments'

// components
import SignIn from './SignIn'
import Register from './Register'

import ApiToken from './ApiToken'
import AlertBox from './AlertBox';

// Hooks cannot run inside mobx-react v5 observer functions.
// Instruction used: debugging.instructions.md
function DarkModeToggle() {
	const [isDarkMode, setIsDarkMode] = React.useState(readDarkModePreference)

	React.useEffect(() => {
		persistDarkModePreference(isDarkMode)
	}, [isDarkMode])

	return (
		<Menu.Item className="theme-toggle">
			<Checkbox
				toggle
				checked={isDarkMode}
				onChange={() => setIsDarkMode(!isDarkMode)}
				label="Dark mode"
				aria-label="Toggle dark mode"
			/>
		</Menu.Item>
	)
}

export const NavBar = observer(() => {
	window.alertBoxRef = React.createRef()

	return (
    
		<Menu inverted borderless attached style={{ flex: "0 0 auto" }}>
		  <AlertBox ref = {window.alertBoxRef} />

		  <Menu.Item as={Link} to="/">
			<Image size='mini' src="/custom-content/Helia_Logo_White_RGB.png" style={{ paddingRight: "10px" }} />
			{fragments.Home.title}
		  </Menu.Item>
		  
		  {isAuthenticated() &&
			<React.Fragment>
			  <Menu.Item as={Link} to="/getting-started">{fragments.GettingStarted.title}</Menu.Item>
			  <Menu.Item as={Link} to="/apis">{fragments.APIs.title}</Menu.Item>
			  {isPolicyStateChangeEnabled() && <Menu.Item as={Link} to="/policy-state-change">Policy State Change</Menu.Item>}
			  <Menu.Item as={Link} to="/b2b-gateway">B2B Gateway</Menu.Item>
			  <Menu.Item as={Link} to="/dashboard">My Dashboard</Menu.Item>
			  <Menu.Item as={Link} to="/faq">FAQ</Menu.Item>
			  {isAIAssistantEnabled() && <Menu.Item as={Link} to="/docs-assistant">Docs Assistant</Menu.Item>}
			  <Menu.Item as={Link} to="/termsandconditions">Terms and Conditions</Menu.Item>
			</React.Fragment>
		  }
		  <Menu.Menu position="right">
			<DarkModeToggle />
			{isAuthenticated() ? (
			  <React.Fragment>
				<ApiToken trigger={<Menu.Item as="a">API Authentication</Menu.Item>} />
				<Menu.Item as="a" onClick={logout}>Sign Out</Menu.Item>
			  </React.Fragment>
			) : (
				<React.Fragment>
				  <SignIn trigger={<Menu.Item as="a">Sign In</Menu.Item>} />
				</React.Fragment>
			)}
			</Menu.Menu>
		</Menu>
	)
})

export default NavBar
